import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import { ModalTheme } from '../../../../../../components/modal';
import { FORM_CHANGE_BOOKING } from '../form';
import { useForm } from 'react-hook-form';
import { RenderForm } from '../../../../../../components/forms';
import { TextLarge } from '../../../../../../components/text';
import { WarningOutlined } from '@ant-design/icons';
import { ContainerButton } from '../../../../../../styles/global-style';
import { ButtonTheme } from '../../../../../../components/buttons';
import { useChangeDateBooking } from '../hooks/useChangeDateBooking';
import { convertYearInputToPayload } from '../../../../../../functions/convert';

export const ChageDateBooking = ({ open, onToggle, item }) => {
  const { claimId, claimCode } = item;
  const bookingDate = item.bookingDate ? dayjs(item.bookingDate).format('DD/MM/YYYY') : null;
  const { control, setValue, getValues, handleSubmit } = useForm({
    defaultValues: {
      bookingDate,
    },
  });
  const { mutate: changeDateBooking } = useChangeDateBooking();

  const onSubmit = (data) => {
    const payload = {
      claimId: claimId,
      claimCode: claimCode,
      bookingDate: convertYearInputToPayload(data.bookingDate),
      remark: data.remark,
    };
    changeDateBooking(payload);
    onToggle({ defaultValue: '' });
  };

  return (
    <ModalTheme title=" " open={open} onToggle={onToggle}>
      <div style={{ marginTop: '20px' }}>
        <WarningOutlined
          style={{ fontSize: '20px', color: '#F87879', display: 'flex', justifyContent: 'center' }}
        />
      </div>
      <div style={{ marginTop: '30px' }}>
        <TextLarge text={'กรุณาติดต่อลูกค้าเพื่อแจ้งการเปลี่ยนแปลง'} bold />
      </div>
      <RenderForm
        control={control}
        forms={FORM_CHANGE_BOOKING({ defaultValues: { bookingDate: item.bookingDate, expireDate: item.expireDate } })}
        setValue={setValue}
        getValues={getValues}
      />
      <ContainerButton right>
        <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
        <ButtonTheme useFor="CANCEL" onClick={onToggle} />
      </ContainerButton>
    </ModalTheme>
  );
};
